import React from "react";

function FemaleSmile() {
  return (
    <>
      <path
        d="m 226.74789,321.19211 c 0,16.35 14.45,32.24 32.28,32.24 v 0 c 17.83,0 29.82,-15.89 29.82,-32.24 z"
        id="path691"
        style={{ fill: "#ffffff" }}
      />
      <path
        d="m 289.98789,321.19211 a 37,37 0 0 1 -9.45,24.26 c -5.84,6.56 -13.92,10.88 -22.83,10.88 -17.83,0 -32.29,-17.31 -32.29,-35.14 h 1.88 c 4.46,13.23 16.4,23.94 30.41,23.94 8.91,0 17,-4.32 22.83,-10.89 a 37.94,37.94 0 0 0 7.57,-13.05 z"
        id="path693"
        style={{ fill: "#db1b1b" }}
      />
      <path
        d="m 257.70789,312.78211 c -17.26,-2.8 -32.28,8.41 -32.28,8.41 h 64.56 c 0,0 -15.03,-11.21 -32.28,-8.41 z"
        id="path695"
        style={{ fill: "#db1b1b" }}
      />
    </>
  );
}

export default FemaleSmile;
